import getExcursionTypes from './clients/getExcursionTypes';
import getRiskCategories from './clients/getRiskCategories';
import postExcursions from './excursions/postExcursions';
import syncExcursions from './excursions/syncExcursions';

export default (axios) => {
  return {
    getExcursionTypes: getExcursionTypes(axios),
    getRiskCategories: getRiskCategories(axios),
    postExcursions: postExcursions(axios),
    syncExcursions: syncExcursions(axios)
  };
};
